import React from 'react';

export default class Policy extends React.Component {
    render() {
        const customLabel = window.TPNS_CatchTheHeartCustomLabel;
        return (
            <div style={{display : 'inline'}} dangerouslySetInnerHTML={{__html:customLabel.poilcy}} />
        );
    }
}

